import { QueryClient } from '@tanstack/react-query';

/**
 * Shared TanStack Query client for the web app and extension surfaces
 * (popup, content iframe). Create one per React root.
 */
export const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        retry: 1,
        staleTime: 30_000,
        refetchOnWindowFocus: false,
      },
    },
  });

export const queryClient = createQueryClient();
